/**
 * @file 教师上课端首页面板配置
 * 文案只写「这块将来显示什么、为什么现在是空的」，不写内部排期代号。
 */

import type { DashCard } from '@lexiloop/shared';

/** 首页三块：今日课程 / 待办 / 数据概览。 */
export const DASH_CARDS: DashCard[] = [
  {
    title: '今日课程',
    description: '今天的 1v1 课程：上课时间、学员、进课入口。',
    emptyTitle: '今天没有排课',
    emptyText: '排课表接进来之后，这里按上课时间顺序列出课程，点一行直接进课堂。',
    tag: '排课接入后显示',
  },
  {
    title: '待办',
    description: '结课后 24 小时内要交的评语、要复核的作业。',
    emptyTitle: '没有待办',
    emptyText: '待办只由真实业务动作产生（结课、交作业、请假），不预置示例条目。',
    tag: '结课动作产生',
  },
  {
    title: '数据概览',
    description: '本月本人销课与课次，口径和财务一致。',
    emptyTitle: '还没有数据',
    emptyText: '统计要等真实课消流水，避免把估算当成业绩。',
    tag: '有课消后显示',
  },
];
